module.exports = __webpack_public_path__ + "static/media/sodo.f79eb8e6.svg";